module.exports = __webpack_public_path__ + "static/media/Giddyapp_3.668c738f.png";